const typePoints = function(ownerStats, opponentStats) {
    const oType = ownerStats.card.element;
    const cType = opponentStats.card.element;    
    let opponent, owner;
    
    // Update owner
    if (oType == 'healer') {
        owner = 'SA';
    } else if (oType == 'warrior') {
        owner = 'DF';
    } else if (oType == 'mystic' || oType == 'magician') {
        owner = 'SP';
    } else if (oType == 'luminous' || oType == 'elemental') {
        owner = 'ST';
    } 

    // Update opponent
    if (cType == 'healer') {
        opponent = 'SA';
    } else if (cType == 'warrior') {
        opponent = 'DF';
    } else if (cType == 'mystic' || cType == 'magician') {
        opponent = 'SP';
    } else if (cType == 'luminous' || cType == 'elemental') {
        opponent = 'ST';
    } 

    return { owner, opponent };
};

const battleLogic = function (ownerCards, opponentCards) {
    let result;
    let battleCard;

    let results = {
        owner: {
            winCardIds: []
        }
        , opponent: {
            winCardIds: []
        }
        , allWinCardIds: []
        , fights: []
    };

    // Battle logic
    battleCard = function(ownerCard, opponentCard){
        let winner = 'unknown'; 
        let fight = { owner: {}, opponent: {} };

        // AP = Attack Points
        // DP = Damage Points
        // BT = Battle Time

        // Owner Power Stats
        let ownerStats = {
            card: ownerCard,
            ST: parseInt(ownerCard.strength),
            SP: parseInt(ownerCard.speed),
            LV: parseInt(ownerCard.level) * 5,
            SA: parseInt(ownerCard.stamina),
            DF: parseInt(ownerCard.defense)
        };

        // Opponent Power Stats
        let opponentStats = {
            card: opponentCard,
            ST: parseInt(opponentCard.strength),
            SP: parseInt(opponentCard.speed),
            LV: parseInt(opponentCard.level) * 5,
            SA: parseInt(opponentCard.stamina),
            DF: parseInt(opponentCard.defense)
        };

        // Update scores with type points
        const updatedStats = typePoints(ownerStats, opponentStats);
        ownerStats[updatedStats.owner] = ownerStats[updatedStats.owner]+5;
        opponentStats[updatedStats.opponent] = opponentStats[updatedStats.opponent]+5;

        // Owner Points
        ownerStats.AP = ownerStats.ST * ownerStats.SP + ownerStats.LV;
        ownerStats.DP = ownerStats.AP / opponentStats.DF;
        ownerStats.BT = opponentStats.SA / ownerStats.DP * 10;

        // Opponent Points
        opponentStats.AP = opponentStats.ST * opponentStats.SP + opponentStats.LV;
        opponentStats.DP = opponentStats.AP / ownerStats.DF;
        opponentStats.BT = ownerStats.SA / opponentStats.DP * 10;

        // TODO: Consolidate STATS

        // Fight specific results
        fight.owner.AP = ownerStats.AP;
        fight.owner.DP = ownerStats.DP;
        fight.owner.BT = ownerStats.BT;

        fight.opponent.AP = opponentStats.AP;
        fight.opponent.DP = opponentStats.DP;
        fight.opponent.BT = opponentStats.BT;

        if (ownerStats.BT < opponentStats.BT) {
            results.allWinCardIds.push(ownerCard.id);
            results.owner.winCardIds.push(ownerCard.id);

            fight.winner = 'owner';

        } else {
            results.allWinCardIds.push(opponentCard.id);
            results.opponent.winCardIds.push(opponentCard.id);

            fight.winner = 'opponent';
        }

        results.fights.push(fight);
    };

    for (let i = 0; i <= 2; i++) {        
        // Gather result per card
        battleCard(ownerCards[i], opponentCards[i]);
    }

    return results;
};

export { battleLogic };


// WEBPACK FOOTER //
// ./src/util/battleLogic.js